@if (selectionState) {
    <bs-digital-pick-selection [pick]="pick" [selection]="selectionState" [betslipType]="betslipType" [isLinear]="true"></bs-digital-pick-selection>
}
<span class="linear-bet-builder-pick-display-header__content"
    >{{ headerTitle }}
    @if (showWarnings) {
        <bs-linear-bet-builder-warning-indicator [pick]="pick"></bs-linear-bet-builder-warning-indicator>
    }
</span>

@if (!hideOdds) {
    <bs-digital-pick-odds [pick$]="pickChange$" [oddsDisplayFormat]="oddsDisplayFormat"></bs-digital-pick-odds>
}
